export default __webpack_public_path__ + "79c565ac706294e2baf92d3c7a5cef35.png";